import React from 'react';

require('styles/utils/GreyCardLabel.styl');

const classNames = require('classnames');

class GreyCardLabel extends React.Component {
  render() {
    const classname = classNames('grey-card-label', this.props.className);
    return (
      <div className={classname}>
        <span>{this.props.label}</span>
      </div>
    );
  }
}

export default GreyCardLabel;
